export const onFormatPhoneNumber = (phoneNumber: string): string | null => {
  const regex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/
  if (regex.test(phoneNumber)) {
    const phoneNumberFormatted = phoneNumber.replace(regex, '($1)$2-$3')
    return phoneNumberFormatted
  } else return null
}
